<template>
    <div ref="container" class="vr-mount" />
</template>

<script lang="ts">
import Vue from "vue";
// Importado para ativar o augmentation de $route e $router no arquivo
import "vue-router";

import Bus from "@/utils/events/bus";

// Interface local — não importa tipos de src/react/ para evitar conflito
// com o namespace JSX global do Vue (shims-tsx.d.ts).
interface ReactHandle {
    unmount(): void;
    render(
        page: "lista" | "edicao",
        id?: number,
        onNavigate?: (path: string) => void,
        onBack?: () => void,
    ): void;
}

export default Vue.extend({
    name: "ReactMountVendaRapida",

    data(): { handle: ReactHandle | null; alive: boolean; temTelaAnterior: boolean } {
        return { handle: null, alive: false, temTelaAnterior: false };
    },

    beforeRouteEnter(_to, from, next) {
        next(vm => {
            const self = vm as InstanceType<typeof Vue> & { temTelaAnterior: boolean };
            self.temTelaAnterior = from.matched.length > 0;
        });
    },

    computed: {
        page(): "lista" | "edicao" {
            return this.$route.name === "vendaRapida-lista" ? "lista" : "edicao";
        },
        routeId(): number | undefined {
            const raw = this.$route.params.id;
            return raw ? parseInt(raw, 10) : undefined;
        },
    },

    async mounted() {
        this.alive = true;
        // Fecha o menu lateral ao abrir a Venda Rápida (mesmo comportamento do /nfe-edicao).
        Bus.$emit("hide-nav-menu", true);
        // @ts-ignore — src/react/ é compilado pelo Babel; os tipos não estão
        // no tsconfig do Vue de propósito para evitar conflitos com JSX global.
        const { mountVendaRapidaApp } = await import(/* webpackChunkName: "vendarapida-react" */ "@/react/mount");
        if (!this.alive) {
            return;
        }
        const container = this.$refs.container as HTMLElement | null;
        if (!container) {
            return;
        }
        this.handle = (mountVendaRapidaApp as (el: HTMLElement) => ReactHandle)(container);
        this.rerender();
    },

    watch: {
        $route(): void {
            this.rerender();
        },
    },

    beforeDestroy() {
        this.alive = false;
        this.handle?.unmount();
        this.handle = null;
    },

    methods: {
        voltar() {
            if (this.temTelaAnterior) {
                this.$router.go(-1);
                return;
            }
            this.$router.push("/").catch(() => undefined);
        },
        rerender() {
            this.handle?.render(
                this.page,
                this.routeId,
                (path: string) => { this.$router.push(path).catch(() => undefined); },
                () => this.voltar(),
            );
        },
    },
});
</script>
